export default () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M10 3V13'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <path
      d='M6 9L10 13L14 9'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M3.5 14.5V15.5C3.5 16.3284 4.17157 17 5 17H15C15.8284 17 16.5 16.3284 16.5 15.5V14.5'
      stroke='#5A607F'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
  </svg>
);

